import { Directive, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field-config.model';
import { FieldComponent } from '../../tokens/field-registry.token';

@Directive()
export abstract class BaseFieldComponent implements FieldComponent {

  @Input() field!: FieldConfig;
  @Input() control!: FormControl;
  /** FormGroup completo; disponible en campos que necesitan acceder a otros controles. */
  @Input() form?: FormGroup;

  // utilidades comunes disponibles en todos los campos
  get isInvalid(): boolean {
    return this.control.invalid && this.control.touched;
  }

  get isPending(): boolean {
    return this.control.pending;
  }

  /** Maps ValidatorType → Angular's actual error key (which may differ in casing). */
  private readonly errorKeyMap: Record<string, string> = {
    minLength: 'minlength',
    maxLength: 'maxlength',
  };

  get errorMessage(): string | null {
    if (!this.isInvalid) return null;
    const errors = this.control.errors;
    if (!errors) return null;

    const rule = this.field.validations?.find(v => {
      const key = this.errorKeyMap[v.type] ?? v.type;
      return errors[key] !== undefined;
    });
    return rule?.message ?? 'Campo inválido';
  }

  /** True cuando el campo tiene un enlace configurado para mostrar en la etiqueta */
  get hasLabelLink(): boolean {
    return !!(this.field?.linkUrl?.trim() && this.field?.linkText?.trim());
  }
}